import { Globe, Megaphone, Radio, Palette, ArrowUpRight, Check } from "lucide-react";

const IMG = {
  web: "https://static.prod-images.emergentagent.com/jobs/9f98c88e-72ad-4b82-ac02-e13b2896f919/images/e97ec98c078836c9a41eaa77914a1dbd3bfc26b280f1286249a475ebe6b86c3d.png",
  marketing: "https://static.prod-images.emergentagent.com/jobs/9f98c88e-72ad-4b82-ac02-e13b2896f919/images/3b91cbcb23df176659c1d4a7594f5499e5c6c7ca857b978105f7637eb3e76bbb.png",
  graphics: "https://static.prod-images.emergentagent.com/jobs/9f98c88e-72ad-4b82-ac02-e13b2896f919/images/85539eea705f5a9d20f61669d21a95ea04a0d7f73c9a3c32404f87979c654d63.png",
  stream: "https://static.prod-images.emergentagent.com/jobs/9f98c88e-72ad-4b82-ac02-e13b2896f919/images/ad4118fc331f83fce7ff11aed4e40030890f78220d7f0c1a4af2b3eaf73cdc51.png",
};

const services = [
  {
    id: "web",
    title: "Web Development",
    desc: "Custom business websites, e-commerce stores, and web applications built with modern technologies for performance and scalability.",
    Icon: Globe,
    image: IMG.web,
    span: "md:col-span-7 md:row-span-2",
    tall: true,
    tag: "01",
    features: ["Business Websites", "E-commerce Stores", "Web Applications"],
  },
  {
    id: "social",
    title: "Social Media Management",
    desc: "Content creation, account management, and audience growth strategies to build your brand presence across platforms.",
    Icon: Megaphone,
    image: IMG.marketing,
    span: "md:col-span-5",
    tag: "02",
    features: ["Content Creation", "Account Management", "Growth Strategies"],
  },
  {
    id: "stream",
    title: "Live Streaming",
    desc: "Professional live streaming for events, conferences, webinars, and ceremonies with reliable multi-platform broadcasting.",
    Icon: Radio,
    image: IMG.stream,
    span: "md:col-span-5",
    tag: "03",
    features: ["Event Streaming", "Conference Coverage", "Webinar Broadcasting"],
  },
  {
    id: "graphics",
    title: "Graphic Designing",
    desc: "Creative branding, marketing materials, social media graphics, and visual content that captures attention and communicates effectively.",
    Icon: Palette,
    image: IMG.graphics,
    span: "md:col-span-7",
    tag: "04",
    features: ["Brand Identity", "Marketing Materials", "Social Media Graphics"],
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-20 md:py-32 px-5 sm:px-6 md:px-10 border-t border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-6 min-w-0">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A00] mb-4 md:mb-5">/ Our Services</div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-6xl font-semibold leading-[1.05] tracking-tight break-words">
              Digital solutions<br />
              that <span className="text-[#FF5A00]">drive growth.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:pt-6">
            <p className="text-zinc-400 max-w-xl text-sm sm:text-base">
              Comprehensive digital services tailored to help your business thrive in the modern
              landscape — from idea to launch and beyond.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 md:auto-rows-[320px]">
          {services.map((s) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`mv-card relative overflow-hidden p-7 md:p-9 col-span-1 ${s.span} flex flex-col justify-between group`}
            >
              {s.image && (
                <img
                  src={s.image}
                  alt=""
                  className={`absolute ${s.tall ? "right-[-40px] bottom-[-30px] w-[50%]" : "right-[-40px] bottom-[-30px] w-[55%]"} opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500 pointer-events-none`}
                />
              )}
              <div className="relative z-10 flex items-start justify-between">
                <s.Icon size={24} className="text-[#FF5A00]" strokeWidth={1.5} />
                <span className="text-[10px] tracking-[0.3em] text-zinc-500">{s.tag}</span>
              </div>
              <div className="relative z-10 max-w-[88%]">
                <h3 className="font-display text-2xl md:text-3xl font-semibold mb-3 tracking-tight">
                  {s.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed mb-5">{s.desc}</p>
                <ul className="space-y-2 mb-6">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-sm text-zinc-300">
                      <Check size={14} className="text-[#FF5A00]" strokeWidth={2.5} />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  data-testid={`service-cta-${s.id}`}
                  className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/80 hover:text-[#FF5A00] transition-colors"
                >
                  <span>Learn More</span>
                  <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
